import { useEffect, useState } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { ClaimReward } from './ClaimReward';
import { RankComponent } from './RankComponent';
import { PackageRankMyProgressModel } from './Ranking.types';
import { flipMeGetInfo } from '../FlipMeWallet/FlipMeWallet.actions';
import { useDispatch } from 'react-redux';

export const Ranking = ({
  ranking
}: {
  ranking: PackageRankMyProgressModel[];
}) => {
  const [isRewardOpen, setIsRewardOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [selectedRank, setSelectedRank] =
    useState<PackageRankMyProgressModel | null>(null);

  const dispatch = useDispatch();

  const { t } = useTranslation('ranking');

  const handleClaim = (rank: PackageRankMyProgressModel) => {
    setStep(1);
    setIsRewardOpen(!isRewardOpen);
    setSelectedRank(rank);
  };

  useEffect(() => {
    dispatch(flipMeGetInfo());
  }, [dispatch]);

  return (
    <>
      <div>
        {ranking?.map((rank, i) => {
          return (
            <RankComponent rank={rank} key={i} handleClaim={handleClaim} />
          );
        })}
      </div>
      <SidebarModal
        isOpen={isRewardOpen}
        setOpen={setIsRewardOpen}
        title={t('new_rank_achived')}
        sidebarWidth={'508px'}>
        <ClaimReward
          step={step}
          setStep={setStep}
          setIsOpen={setIsRewardOpen}
          selectedRank={selectedRank}
        />
      </SidebarModal>
    </>
  );
};
